import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "store/slices/userSlice";
import vitalReducer from "store/slices/vitalSlice";
import budgetReducer from "store/slices/budgetSlice";
import fileReducer from "store/slices/vaultSlice";
import appointmentReducer from "store/slices/appointmentSlice";

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["userData"], // which reducer want to store
  blacklist: ["vitalData", "budgetData", "fileData", "appointmentData"], // which reducer want to not store
};

const rootReducer = combineReducers({
  userData: userReducer,
  vitalData: vitalReducer,
  budgetData: budgetReducer,
  fileData: fileReducer,
  appointmentData: appointmentReducer
  //all reducers here
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
